import React, { useState, useEffect } from 'react';
import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import Input from 'components/Input';
import { ILotProduct, LotSelectedProps } from './interface';
import Validator from 'components/Validator';
import AutoComplete from 'components/AutoComplete';
import LotService from 'services/lot.service';
import AutoCompleteLotModel from 'components/AutoComplete/Lot';
import { DateOutputStr } from 'utils/DateOutput';

const LotProduct: React.FC<ILotProduct> = (props) => {
  const { lot, setLot, products, isEditing } = props;
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [lotExpirationDate, setLotExpirationDate] = useState(lot.lotExpirationDate || '');
  const [lotManufacturingDate, setLotManufacturingDate] = useState(lot.lotManufacturingDate || '');

  const _lotService = new LotService();

  const onChangeLot = (e: any) => {
    setLot({ number: e });
  };

  useEffect(() => {
    if (!isEditing) {
      setShowAutoComplete(false);
      setLot({
        number: '',
        lotExpirationDate: '',
        lotManufacturingDate: ''
      });
    }
  }, [products]);


  const setAllLots = (data: LotSelectedProps) => {
    setShowAutoComplete(false);
    setLot({
      ...lot,
      number: data.identifier || '',
      lotExpirationDate: data.lotExpirationDate,
      lotManufacturingDate: data.lotManufacturingDate
    });

    setLotExpirationDate(DateOutputStr(data.lotExpirationDate, 'yyyy-MM-dd'));
    setLotManufacturingDate(DateOutputStr(data.lotManufacturingDate, 'yyyy-MM-dd'));
  };

  const setDate = (date: string, expiration: boolean) => {
    if (expiration) {
      setLotExpirationDate(date);
      setLot({
        ...lot,
        lotExpirationDate: date
      });
    } else {
      setLotManufacturingDate(date);
      setLot({
        ...lot,
        lotManufacturingDate: date
      });
    }
  };

  return (
    <Row className="flex-md-column mt-3">
      <Column
        className={'flex-1 max-w-md-100 mt-md-2'}
      >
        <Validator value={lot.number} name={products.length > 0 ? 'Lote do produto' : 'Produto'} required>
          <Text className="mb-2 color-blue-gray" size={12}>
            Lote do produto
          </Text>
          <AutoComplete
            show={showAutoComplete}
            onSelect={(data: any) => setAllLots(data)}
            request={(value: any) =>
              _lotService.autoComplete(value.toLowerCase(), products[0])
            }
            content={AutoCompleteLotModel}
            maxResults={5}
          >
            <Input
              id="lot"
              stateName="lot"
              onChange={(e: any) => onChangeLot(e.target.value.toUpperCase())}
              onFocus={() => setShowAutoComplete(true)}
              name="Lote do produto"
              className="w-100"
              type="text"
              value={lot.number}
              placeholder="Descrição"
              disabled={products.length > 0 ? false : true}
            />
          </AutoComplete>
        </Validator>
      </Column>

      <Column className="flex-1 max-w-md-100 mt-md-2 ml-2 ml-md-0">
        <Text className="mb-2 color-blue-gray" size={12}>
          Data de fabricação
        </Text>
        <Input
          name="Data de fabricação"
          stateName="manufacturingDate"
          onFocus={() => setShowAutoComplete(false)}
          type="date"
          placeholder="Data de fabricação"
          value={lotManufacturingDate}
          onChange={(e: any) => setDate(e.target.value, false)}
          disabled={products.length > 0 ? false : true}
          required
        />
      </Column>

      <Column className="flex-1 max-w-md-100 mt-md-2 ml-2 ml-md-0">
        <Text className="mb-2 color-blue-gray" size={12}>
          Data de validade
        </Text>
        <Input
          name="Data de validade"
          stateName="manufacturingDate"
          onFocus={() => setShowAutoComplete(false)}
          type="date"
          placeholder="Data de validade"
          value={lotExpirationDate}
          onChange={(e: any) => setDate(e.target.value, true)}
          disabled={products.length > 0 ? false : true}
          required
        />
      </Column>
    </Row>
  );
};

export default LotProduct;
